var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MenuSurfaceAnchor, MenuSurface, MenuItem } from '@rmwc/menu';
import IconButton from './IconButton';
import Button from './Button';
import withCustomLink from '../hocs/withCustomLink';
/**
 * Menu Component, uses icon component, allows to build custom menus
 *
 * @see **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.4.0/content/components/menu.md
 */
var Menu = function (_a) {
    var open = _a.open, setOpen = _a.setOpen, options = _a.options, content = _a.content, _b = _a.onSelect, onSelect = _b === void 0 ? function () { } : _b, button = _a.button, iconButton = _a.iconButton, _c = _a.className, className = _c === void 0 ? '' : _c, LinkTag = _a.linkTag;
    if (!options && !content) {
        throw new Error('You should define options or content prop');
    }
    var style = { top: '40px' };
    var onClose = function () { return setOpen(false); };
    var renderContent = function () {
        return (React.createElement(MenuSurface, { open: open, onClose: onClose, style: style, className: "madonna-menu " + className, role: "menu" },
            React.createElement("div", { className: "madonna-menu-content" }, content)));
    };
    var renderOption = function (option) {
        if (option.to) {
            return (React.createElement(LinkTag, { to: option.to, role: "menuitem" }, option.title));
        }
        else {
            return (React.createElement("div", __assign({ role: "menuitem" }, option), option.title));
        }
    };
    var renderOptions = function () {
        return (React.createElement(MenuSurface, { open: open, onClose: onClose, onSelect: function (evt) { return onSelect && onSelect(evt.detail.index); }, style: style, className: "madonna-menu " + className, role: "menu", tag: "ul" }, options &&
            options.map(function (option, index) { return (React.createElement(MenuItem, { key: "menu-item-" + index, tag: "li", role: "presentation" }, renderOption(option))); })));
    };
    return (React.createElement(MenuSurfaceAnchor, null,
        content && renderContent(),
        options && renderOptions(),
        typeof button !== 'undefined' && (React.createElement(Button, __assign({ onClick: function () { return !open && setOpen(true); } }, button))),
        typeof iconButton !== 'undefined' && (React.createElement(IconButton, __assign({ onChange: function () { return !open && setOpen(true); } }, iconButton)))));
};
export default withCustomLink(function (_a) {
    var customLinkTag = _a.customLinkTag, props = __rest(_a, ["customLinkTag"]);
    return (React.createElement(Menu, __assign({ linkTag: customLinkTag }, props)));
});
//# sourceMappingURL=Menu.js.map